import { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import { GlobalBanner } from '../../utils/types'

export type AccountsView = "LIVE" | "DEMO" | "ARCHIVED"

export type DashboardState = {
    showSidebar: boolean
    pageFooter: React.ReactNode | null
    pageBanner: GlobalBanner | null
    simplifiedLevelTwoRootPage?: string
    accountsView?: AccountsView
}

const initialState: DashboardState = {
    showSidebar: true,
    pageFooter: null,
    pageBanner: null,
    simplifiedLevelTwoRootPage: undefined,
    accountsView: undefined
}

const slice = createSlice({
    name: 'dashboard',
    initialState: initialState,
    reducers: {
        toggleSidebar: (state: DashboardState) => {
            state.showSidebar = !state.showSidebar
        },
        hideSidebar: (state: DashboardState) => {
            state.showSidebar = false
        },
        showSidebar: (state: DashboardState) => {
            state.showSidebar = true
        },
        setPageFooter: (state: DashboardState, action: PayloadAction<React.ReactNode | null>) => {
            state.pageFooter = action.payload
        },
        setPageBanner: (state: DashboardState, action: PayloadAction<GlobalBanner | null>) => {
            state.pageBanner = action.payload
        },
        setSimplifiedLevelTwoRootPage: (state: DashboardState, action: PayloadAction<string | undefined>) => {
            state.simplifiedLevelTwoRootPage = action.payload
        },
        setAccountsView: (state: DashboardState, action: PayloadAction<AccountsView | undefined>) => {
            state.accountsView = action.payload
        },

    }
})

const { actions, reducer } = slice

export const { toggleSidebar,
    showSidebar,
    hideSidebar,
    setPageFooter,
    setPageBanner,
    setSimplifiedLevelTwoRootPage,
    setAccountsView
} = actions
export default reducer